import { useQuery } from '@tanstack/react-query';
import { reportService } from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';

export const useGoodsReportable = () => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: ['goodsReportable', goodsSno],
    queryFn: () => reportService.getGoodsReportable(goodsSno),
  });
};
